module.exports = __webpack_public_path__ + "static/media/NIGHT BIKE.edfacfbb.jpeg";